import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CustomerService, UserSessionService } from '../services';
import { TokenService } from '../services/utils/token.service';

@Injectable({
    providedIn: 'root',
})
export class RedirectGuard {
    constructor(
        private readonly router: Router,
        private readonly tokenService: TokenService,
        private readonly customerService: CustomerService,
        private readonly userSessionService: UserSessionService
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const isGuest = this.customerService.isGuest();

        if (state.url.toLowerCase().includes('schenker/account-type')) {
            window.location.replace(environment.projects.sprintPayv7 + `/schenker/account-type`);
            return false;
        }

        if (this.tokenService.isAuthenticated()) {
            const url = !isGuest ? '/admin/home' : '/login';
            return this.router.createUrlTree([url]);
        }

        this.userSessionService.logout();
        return false;
    }
}
